module.exports = __webpack_public_path__ + "static/media/profile_pic.ec9f0bbc.jpg";